export interface IFeatureCodeMapping {
    [key: string]: number;
}

export interface ISolutionFeatureMapping {
    [key: string]: IFeatureCodeMapping;
}

export function addCrmAndMoreEssentialsPrev(mapping: ISolutionFeatureMapping) {
    mapping["CRMandMore_CRMEssentials_Prev"] = { "CRM Essentials": 100 };
}

export const featureMappingFallback: ISolutionFeatureMapping = {
    "CRMandMore_CRMEssentials": { // Use "menucard" for CRM Essentials v9.2.x and higher
        "Address Management": 103,
        "Address Connect": 104,
        "Salutation Management": 105,
        "Data Synchronization": 106,
        "Data Aggregation": 107,
        "Sequence Number": 108
    },
    "CRMandMore_CRMEssentials_Prev": { "CRM Essentials": 100 }, // Don't use "menucard" for CRM Essentials versions lower than v9.2.x
    "CRMandMore_DataQualityPack": { // Use "menucard" for CRM Essentials v9.2.x and higher
        "Data Synchronization": 106,
        "Data Aggregation": 107,
        "Sequence Number": 108
    },
    "CRMandMore_AddressAssist": {
        "Address Management": 103,
        "Address Connect": 104,
        "Salutation Management": 105,
        "Phone Number Formatting": 109
    },
    "CRMandMore_QuickFind": { "Quick Find": 101 },
    "CRMandMore_TilesView": { "Tiles View": 102 },
    "CRMandMore_MembersBase": { "Members Base": 200 },
    "CRMandMore_Groups": { "Groups": 201 },
    "CRMandMore_MembersPublications": { "Members Publications": 202 },
    "CRMandMore_DataExport": { "Data Export": 301 },
    "CRMandMore_DirectDebit": { "Direct Debit": 302 },
    "CRMandMore_Invoicing": { "Invoicing": 303 },
    "CRMandMore_Payments": { "Payments": 304 },
    "CRMandMore_Events": { "Events": 305 },
    "CRMandMore_Positions": { "Positions": 306 },
    "CRMandMore_Anonymization": { "Anonymization": 410 },
    "CRMandMore_ComplianceConnect": { "Compliance Connect": 500 },
    /***** CRM Partners AG *****/
    "CRMPAG_RentalLife": { "Rental Life": 49001 },
    "CRMPAG_ChemicalLife": { "Chemical Life": 49002 },
    /***** AXtension *****/
    "CRMandMore_DataAnonymizer": { "Data Anonymizer": 410 }
};


// WEBPACK FOOTER //
// ./ClientApp/app/components/solution-featurecode-mapping.ts